export default __webpack_public_path__ + "media/images/home/slide_participation_request_sm-b770492548e57c375b6e4aab5b53c668.jpg";